// @ts-expect-error: Error connected with bootstrap-vue incompatible with Vue 3
import Vue from 'vue'

import {
  LayoutPlugin,
  ImagePlugin,
  FormPlugin,
  FormInputPlugin,
  FormGroupPlugin,
  FormCheckboxPlugin,
  ButtonPlugin,
  SpinnerPlugin,
  InputGroupPlugin,
  FormSelectPlugin,
  AvatarPlugin,
  FormTextareaPlugin,
  NavPlugin,
  IconsPlugin,
  CollapsePlugin,
  ModalPlugin,
  TablePlugin,
  SkeletonPlugin,
  CardPlugin,
  TooltipPlugin,
  FormRadioPlugin,
  TabsPlugin,
  ProgressPlugin,
  FormFilePlugin,
  ToastPlugin,
  AlertPlugin
} from 'bootstrap-vue'

// const supressWarningsForComponents = [
//   '<BCard>',
//   '<BContainer>',
//   '<BVTransporter>',
//   '<BModal>',
//   '<BVTransition>',
//   '<BVTooltipTemplate>'
// ]

// const checkIfSupressWarnings = (copy: string): boolean => {
//   return supressWarningsForComponents.some((component) => copy.includes(component))
// }
// Vue.config.warnHandler = (msg: string, vm: Vue, trace: string) => {
//   if (checkIfSupressWarnings(trace) || checkIfSupressWarnings(msg)) return
//   console.warn(`[Vue warn]: ${msg}\nTrace: ${trace}`)
// }

Vue.use(FormPlugin)
Vue.use(LayoutPlugin)
Vue.use(ImagePlugin)
Vue.use(FormInputPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(ButtonPlugin)
Vue.use(SpinnerPlugin)
Vue.use(InputGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(AvatarPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(NavPlugin)
Vue.use(IconsPlugin)
Vue.use(TablePlugin)
Vue.use(SkeletonPlugin)
Vue.use(CardPlugin)
Vue.use(TooltipPlugin)
Vue.use(CollapsePlugin)
Vue.use(ModalPlugin)
Vue.use(FormRadioPlugin)
Vue.use(TabsPlugin)
Vue.use(ProgressPlugin)
Vue.use(FormFilePlugin)
Vue.use(ToastPlugin)
Vue.use(AlertPlugin)
